module.exports = __webpack_public_path__ + "static/fallingPills-13aacaefda98fd8c8cca847b707c7c8d.png";